var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMostLiked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49.464,
    cy: 49.464,
    r: 49.464,
    fill: "#01A0C6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2668 30.0447C52.6825 26.0336 57.9156 23.4954 63.3681 23.4954C73.0197 23.4954 80.603 31.0787 80.603 40.7303C80.603 52.5656 69.9662 62.2111 53.8503 76.8249L53.8106 76.8609L49.2668 80.9973L44.7231 76.8922L44.5994 76.7798C28.5305 62.1775 17.9307 52.5451 17.9307 40.7303C17.9307 31.0787 25.514 23.4954 35.1656 23.4954C40.6181 23.4954 45.8512 26.0336 49.2668 30.0447ZM49.2669 72.5365L49.5803 72.2231C64.4963 58.7173 74.3358 49.7864 74.3358 40.7303C74.3358 34.4631 69.6354 29.7626 63.3682 29.7626C58.5424 29.7626 53.842 32.8649 52.2125 37.158H46.3526C44.6918 32.8649 39.9914 29.7626 35.1656 29.7626C28.8984 29.7626 24.198 34.4631 24.198 40.7303C24.198 49.7864 34.0375 58.7173 48.9535 72.2231L49.2669 72.5365Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMostLiked);
export default __webpack_public_path__ + "static/media/most-liked.4c1f26bf.svg";
export { ForwardRef as ReactComponent };